module.exports = __webpack_public_path__ + "static/media/close_btn.cd6e7e38.svg";